// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.hero{\n\t\tmin-height: 512px; background: url('https://wfonline.s3.eu-west-1.amazonaws.com/assets/bookyear.jpg') no-repeat top; background-size: contain;\n\t\tposition: relative;\n}\n.year{ position: absolute; bottom:40px; text-align: center; width: 100%; font-size: 80px; color:var(--main-blue-6);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
